export enum DataSource {
    Cache = 'cache',
    Raw = 'raw',
}
